import { useQuery } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useChannelPost = (cid: string, id: number | string) => {
  return useQuery({
    queryKey: ['channel_posts', id],
    queryFn: () => _a.channelPost(cid, id),
  });
};
